import {
  DefaultService,
  Organisation,
  OrganisationType,
} from "@/api/SolarCloudApi";
import { v4 as uuid } from "uuid";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { MutationConfig } from "@/lib/react-query";
import getUserQueryOptions from "../user/useUser";
import { isValidABN } from "@/util/isValidABN";
import { z } from "zod";

async function updateOrganisation(organisation: Organisation) {
  if (!organisation.uuid) {
    throw new Error("Organisation UUID is required");
  }
  const response = await DefaultService.updateOrganisation(
    organisation.uuid,
    organisation
  );
  return response;
}

type UseUpdateOrganisationOptions = {
  mutationConfig?: MutationConfig<typeof updateOrganisation>;
};

export function useUpdateOrganisation({
  mutationConfig,
}: UseUpdateOrganisationOptions = {}) {
  const queryClient = useQueryClient();

  const { onSuccess, onError, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      queryClient.invalidateQueries({
        queryKey: getUserQueryOptions().queryKey,
      });
      onSuccess?.(data, ...args);
    },
    onError: (error, ...args) => {
      console.error("Error updating organisation:", error);
      onError?.(error, ...args);
    },
    ...restConfig,
    mutationFn: updateOrganisation,
  });
}
